import { Button } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

export const NarrativeFeedback = () => {
  const makeTypeformPopup = useTypeformDrawer('RpQD7Uxc');

  return (
    <div className="max-h-min-content grid grid-flow-col items-center justify-start gap-x1 rounded-x0 bg-p-grey-100 px-x2 py-x1 lg:rounded-x2">
      <InformationSolid className="fill-softer" />
      <div className="text-xs text-soft">Narratives are currently in beta</div>
      <Button
        styleType="strongLink"
        className="text-xs"
        onClick={makeTypeformPopup}
      >
        Give Feedback
      </Button>
    </div>
  );
};
